import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {

  constructor(private http: HttpClient) { }

  getAllAppointmentWithCount(data:any): Observable<any> {
    return this.http.post(environment.getAllAppointmentWithCount,data);
  }

  getAppointmentOverviewStats(data:any): Observable<any> {
    return this.http.post(environment.getAppointmentOverviewStats,data);
  }
  
  getPatient(data:any): Observable<any> {
    return this.http.post(environment.getPatient,data);
  }

  getAllAppointment(data:any): Observable<any> {
    return this.http.post(environment.getAllAppointment,data);
  }
  getAllAppointmentByPatientId(data:any): Observable<any> {
    return this.http.post(environment.getAllAppointmentByPatientId,data);
  }
  getAllSchedule(data:any): Observable<any> {
    return this.http.post(environment.getAllSchedule,data);
  }
  getSchedule(data:any): Observable<any> {
    return this.http.post(environment.getSchedule,data);
  }
  getAvailableDays(data:any): Observable<any> {
    return this.http.post(environment.getAvailableDays,data);
  }
  getSlots(data:any): Observable<any> {
    return this.http.post(environment.getSlots,data);
  }
  
  createAppointment(data:any): Observable<any> {
    return this.http.post(environment.createAppointment,data);
  }
  updateAppointment(data:any): Observable<any> {
    return this.http.post(environment.updateAppointment,data);
  }

  updateAppointmentData(data:any): Observable<any> {
    return this.http.post(environment.updateAppointmentData,data);
  }

  updatePatient(data:any): Observable<any> {
    return this.http.post(environment.updatePatient,data);
  }
  
  
  getDepartments(data:any): Observable<any> {
    return this.http.post(environment.getAllDepartment,data);
  }

  getUsersByDepartments(data:any): Observable<any> {
    return this.http.post(environment.getUserByDepartment,data);
  }
  getPatientBySearch(data:any): Observable<any> {
    return this.http.post(environment.getPatientBySearch,data);
  }
  checkInOpdPatientData(data:any): Observable<any> {
    return this.http.post(environment.checkInOpdPatientData,data);
  }

  saveVitals(data:any): Observable<any> {
    return this.http.post(environment.saveVitals, data);
  }

  saveEncounter(data:any): Observable<any> {
    return this.http.post(environment.saveEncounter, data);
  }

  saveSoapNote(data:any): Observable<any> {
    return this.http.post(environment.saveSoapNote, data);
  }

  addMedication(data:any): Observable<any> {
    return this.http.post(environment.addMedication, data);
  }

  getPatientJourney(data:any): Observable<any> {
    return this.http.post(environment.getPatientJourney, data);
  }

  getEncounter(data:any): Observable<any> {
    return this.http.post(environment.getEncounter, data);
  }

  getVitals(data:any): Observable<any> {
    return this.http.post(environment.getVitals, data);
  }

  getMedications(data:any): Observable<any> {
    return this.http.post(environment.getMedications, data);
  }

  getSoapNote(data:any): Observable<any> {
    return this.http.post(environment.getSoapNote, data);
  }

  getUserByDepartmentSchedule(data:any): Observable<any> {
    return this.http.post(environment.getUserByDepartmentSchedule,data);
  }

  importAppointments(data:any): Observable<any> {
    return this.http.post(environment.importAppointments,data);
  }
  refundAppointmentFees(data:any): Observable<any> {
    return this.http.post(environment.refundAppointmentFees,data);
  }
  getAppointmentReport(data:any): Observable<any> {
    return this.http.post(environment.getAppointmentReport,data);
  }
  
  
}
